import { FloorInsulationTypes } from "@iko-design-center/shared";
import React from "react";
import { Spacer } from "../../common/Spacer";
import { H1, P } from "../../common/Typography";
import { RadioButton } from "../../common/RadioButton";
import { useFloorInsulation } from "./floorInsulation.hooks";
import { getFloorInsulationOptionTranslations } from "./translations";
import { Sidebar } from "../Sidebar";
import { Intro, RadioButtonList } from "../../viewer/DesignCenter";
import { isMobile } from "../../../services/helpers.service";
import { useTabs } from "../../navigation/tabs.hook";

export const FloorInsulation = () => {
  const {
    t,
    floorInsulationType,
    setFloorInsulationType,
    nextButtonDisabled,
    handleNextButtonClick,
  } = useFloorInsulation();

  const { currentStep, tabs } = useTabs();
  const totalSteps = tabs[tabs.length - 1].step

  return (
    <Sidebar
      handleNextButtonClick={handleNextButtonClick}
      nextButtonText={`${t("floor.floorInsulation.nextButton")} (${currentStep + 1}/${totalSteps})`}
      nextButtonDisabled={nextButtonDisabled}
    >
      <Intro>
        <H1>{t("floor.floorInsulation.title")}</H1>
        <Spacer heightPx={12} />
        <P lineHeightPx={22}>{t("floor.floorInsulation.subtitle")}</P>
        {!isMobile() && <Spacer heightPx={32} />}
      </Intro>
      <RadioButtonList>
        <RadioButton
          value={FloorInsulationTypes.ENERTHERM_ALU}
          checked={floorInsulationType === FloorInsulationTypes.ENERTHERM_ALU}
          onClick={() =>
            setFloorInsulationType(FloorInsulationTypes.ENERTHERM_ALU)
          }
          text={getFloorInsulationOptionTranslations(
            t,
            FloorInsulationTypes.ENERTHERM_ALU
          )}
          disabled={false}
        />
        {!isMobile() && <Spacer heightPx={10} />}
        <RadioButton
          value={FloorInsulationTypes.ENERTHERM_KR_ALU}
          checked={
            floorInsulationType === FloorInsulationTypes.ENERTHERM_KR_ALU
          }
          onClick={() =>
            setFloorInsulationType(FloorInsulationTypes.ENERTHERM_KR_ALU)
          }
          text={getFloorInsulationOptionTranslations(
            t,
            FloorInsulationTypes.ENERTHERM_KR_ALU
          )}
          disabled={false}
        />
      </RadioButtonList>
    </Sidebar>
  );
};
